import { ProjectConfigType } from '~/projects/types';

export const PROJECT_NAME = 'JustDone';

const config: ProjectConfigType = {
  name: PROJECT_NAME,
  getLogo: () => {
    const { ReactComponent } = require('./assets/logo.svg');
    return ReactComponent;
  },
  getBigLogo: () => {
    const { ReactComponent } = require('./assets/logo_big.svg');
    return ReactComponent;
  },
  getSendIcon: () => {
    const { ReactComponent } = require('./assets/send.svg');
    return ReactComponent;
  },
  supportEmail: 'support@justdone.ai',
  isExtensionAvailable: true,
};

export default config;
